<template>
  <b-modal id="modal-brand-creator-sent"
           centered
           hide-footer
           @hidden="hideModal"
  >
    <template #modal-header="{ close }">
      <div class="d-flex justify-content-end" style="z-index: 100;">
        <img src="../../assets/img/icon/delete-img@4x.png"
                      alt="Bootstrap" width="16" height="16"
                      @click="close()">
      </div>
    </template>
    <div class="success-modal__body d-flex flex-column align-items-center">
      <span style="font-weight: bold;margin-bottom: 4px;">
        電郵已發送至<br>
        {{ invitationEmail }}
      </span>
      <span style="color: rgb(85,91,95);">如未收到電郵，請檢查垃圾郵件箱 (Spam)。</span>
    </div>
  </b-modal>
</template>

<script>
import vModelMixin from '@/mixins/v-model';

export default {
  mixins: [vModelMixin],
  props: {
    invitationEmail: String,
  },
  components: {

  },
  methods: {
    hideModal() {
      this.$bvModal.hide('modal-brand-creator-sent');
      this.$emit('close-modal', true);
    },
  },
};
</script>

<style scoped lang="scss">
.success-modal {
  &__body {
    // padding: 12px;
    text-align: center;
  }

  &__msg {
    font-size: 1.25rem;
    font-weight: 500;
    color: #636d77;
  }
}

::v-deep {
  .modal-header {
    position: absolute;
    right: 0;
    border-bottom: none !important;
    justify-content: flex-end !important;
  }

  .modal-content {
    border-radius: 12px;
    background-color: rgb(242, 244, 246);
  }
}
</style>
